import cdc from "assets/images/cdc.jpeg";
import datiImpresa from "assets/images/dati-impresa.png";
import passport from "assets/images/passport.png";
import phone from "assets/images/phone.png";
import tesseraSanitaria from "assets/images/tessera-sanitaria.png";
import BftButton from "common/components/button";
import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import Footer from "layout/components/footer";
import Sidebar from "layout/components/sidebar";
import Topbar from "layout/components/topbar";
import { Card, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

interface StepCardProps {
	image: string;
	title: string;
	subtitle: string;
}

const title = "Prima di iniziare assicurati di avere:";

const requirements = [
	{
		image: cdc,
		title: "Formalizzato l'avvio della tua attività",
		subtitle: "Presso CCIAA e/o AdE.",
	},
	{
		image: datiImpresa,
		title: "Dati relativi alla tua impresa",
		subtitle: "Dati aziendali.",
	},
	{
		image: passport,
		title: "Documento di riconoscimento e/o SPID",
		subtitle: "Carta d'identità, patente o passaporto.",
	},
	{
		image: tesseraSanitaria,
		title: "Tessera sanitaria",
		subtitle: "Come ulteriore documento d'identificazione.",
	},
	{
		image: phone,
		title: "Smartphone con SIM attiva",
		subtitle: "Per poter firmare il contratto.",
	},
	
];

const RequirementsPage: React.FC = () => {
	const navigate = useNavigate();

	const goNext = () => {
		navigate(AppRouterService.get(PathEnum.step1));
	};

	return (
		<>
			<Sidebar />
			<div className="wrapper d-flex flex-column min-vh-100">
				<div className="body flex-grow-1 px-0">
					<Topbar />
					<div className="container-fluid pre-step-body px-0">
						<div className="text-center">
							<header className="App-header">
								<h2 className="mb-3">{title}</h2>
								<Row xs={1} sm={2} md={5} className="my-4 mx-2">
									{requirements.map((requirement, index) => (
										<StepCard
											key={index}
											image={requirement.image}
											title={requirement.title}
											subtitle={requirement.subtitle}
										/>
									))}
								</Row>
								<BftButton className="btn-buffetti" onClick={goNext}>
									Ho tutto, iniziamo
								</BftButton>
							</header>
						</div>
					</div>
				</div>
				<Footer />
			</div>
		</>
	);
};

const StepCard = (props: StepCardProps) => {
	const { image, title, subtitle } = props;
	return (
		<Col>
			<Card className="shadow requirements">
				<Card.Img variant="top" src={image} style={{ minHeight: "200px" }} />
				<Card.Body className="card-body">
					<div className="text-left pt-1">
						<h5>{title}</h5>
						<span className="gray font-weight-bold m-0">
							<small>{subtitle}</small>
						</span>
					</div>
				</Card.Body>
			</Card>
		</Col>
	);
};

export default RequirementsPage;
